module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABEElEQVQokY2SsSuGURTGfx8WZZDNO1AGCdstq00Gk0FZLOr0mZT8AbLoMygZ1MNIUZJYTLIYDGeQQSaUwR9g9urofvq8PuUs9z7PeZ5zbufcWlmWVEPSGvBhZuvVXEfzImlB0lCGvUBf5qckLf4wSNoG9oGxX+2gH9iV1AjQWRTFNLADzJrZRZDuHhwppcuU0p2734fG3W+iwzJwaGbnLVWvgasmMLMz4ABY7QImgfnWN2RBNU6BvejQDby1EVTjNYYRhmdg+B+GUeAlDCfAkqTaX8qcqwPHYdgABoBGO1PmNoEizq9NSxoHYqRPwBZwC4RwAlgBBoEZM3v4/hqSevKI54ARIBKPwFHswMzeAT4B4GJXaiAKxngAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tc.png
// module id = gtGE
// module chunks = 1